import React, { useEffect, useState } from "react";
import { Controller } from "react-hook-form";
import Select from "react-select";
import { Col } from "reactstrap";
import { ErrorMessage } from "../../../../../utils/ErrorMessage";
import { selectInputStyle } from "../../../../../utils/SelectInputStyles";
import { supplierTypes } from "../../../../radioTypes/radioTypes";
import InputField from "../../../inputs/InputField";
import MobileNoInputField from "../../../inputs/MobileNoInputField";
import RadioButtonsGroup from "../../../RadioButtonsGroup/RadioButtonsGroup";
import { toastMessage } from "../../../../commonFunctions";
import { CustomerDetailsFormSchema } from "../FormComponentSchema";
import useLocationApi from "../../../../../hooks/useLocationApi";
import { CountryListAaray, CountryLists } from "../../../../../pages/Contact/EditContact/EditContactSchema";
import { useSelector } from "react-redux";

const SuppliersDetailForm : React.FC<CustomerDetailsFormSchema> = ({
  // accountGrpDefaultValue,
  paymentTermArr,
  accountGroupArr,
  register,
  errors,
  control,
  newContactCreatedDetail,
  handleBlurFirstName,
  handleBlurLastName,
  handleBlurCompanyName,
  handleBlurContactNo,
  handleBlurCreditAmount,
  handleBlurDebitAmount,
  setValue,
}) => {
  const [countryCodeImg, setCountryCodeImg] = useState<CountryLists[]>([]); 
  const { getCountryList } = useLocationApi();
  const accountGroupArrs = accountGroupArr.map(({ label, value }) => ({
    label,
    value: value.toString(), // Convert the number to string
  }));
  const sessionList = useSelector((state: any) => state.sessionData.sessionScope);
  const taxtype = sessionList?.governmentTaxType || "gst";
  useEffect(() => {
     const fetchCountryList = async () => {
       try {
         const countryList = await getCountryList();
   
         if (countryList) {
           const parsedResult = CountryListAaray.safeParse(countryList?.response);
             if (parsedResult.success) {
      
             setCountryCodeImg(parsedResult.data)
         
           } else {
             console.error("Parsing error:", parsedResult.error.format());
           }
         } else {
           console.error("Response data is null or undefined.");
         }
       } catch (error) {
         console.error("Error fetching country list:", error);
       }
     };
   
     fetchCountryList();
   }, [newContactCreatedDetail]);

  return (
    <>
      <div className="form-container">
        <Col md={"auto"}>
          <InputField
            
            labelName="First Name"
            placeholder="First Name"
            name="firstName"
            register={register}
            onChange={handleBlurFirstName}
            errorMessage={ErrorMessage(errors?.firstName?.message)}
          />
        </Col>

        <Col>
          <InputField
            
            labelName="Last Name"
            placeholder="Last Name"
            name="lastName"
            onChange={handleBlurLastName}
            register={register}
            errorMessage={ErrorMessage(errors?.lastName?.message)}
          />
        </Col>

        <Col md={"auto"}>
          <InputField
            
            labelName="Company Name"
            placeholder="Company Name"
            name="companyName"
            register={register}
            // onChange={handleBlurCompanyName}
            onChange={handleBlurCompanyName}
            required
            errorMessage={ErrorMessage(errors?.companyName?.message)}
          />
        </Col>

        <Col>
          <InputField
            
            labelName="Code"
            placeholder="Code"
            name="code"
            id="code"
            register={register}
            errorMessage={ErrorMessage(errors?.code?.message)}
          />
        </Col>

        <Col>
          <InputField
            
            labelName="PAN No."
            placeholder="PAN No."
            name="panNo"
            register={register}
            errorMessage={ErrorMessage(errors?.panNo?.message)}
          />
        </Col>
      </div>

      <div className="form-container">
        <Col className="responsive-MobileInput" md={"auto"}>
          <MobileNoInputField
            newContactCreatedDetail={newContactCreatedDetail}
            inputName="mobNo"
            labelName="Mobile No."
            name="mobNo"
            control={control}
            handleBlur={handleBlurContactNo}
            placeHolder={"Mobile No."}
            setValue={setValue}
            countryCodeImg={countryCodeImg}
          />
          {ErrorMessage(errors?.mobNo?.message)}
        </Col>

        <Col>
          <InputField
            id="telephone"
            labelName="Telephone No."
            placeholder="Telephone No."
            name="telephone"
            register={register}
            inputType="number"
            onKeyDown={(evt) =>
              ["e", "E", "+", "-", "."].includes(evt.key) &&
              evt.preventDefault()
            }
            errorMessage={ErrorMessage(errors?.telephone?.message)}
          />
        </Col>

        <Col className="responsive-MobileInput" md={"auto"}>
          <MobileNoInputField
            
            labelName="Whats app No."
            inputName="whatsappNo"
            name="whatsappNo"
            control={control}
            newContactCreatedDetail={newContactCreatedDetail}
            placeHolder={"Whatspp No."}
            setValue={setValue}
            countryCodeImg={countryCodeImg}
          />
          {ErrorMessage(errors?.whatsappNo?.message)}
        </Col>

        <Col>
          <InputField
            id="Email"
            labelName="Email"
            placeholder="Email"
            name="email"
            register={register}
            errorMessage={ErrorMessage(errors?.email?.message)}
          />
        </Col>

        <Col>
          <InputField
            id="tanNo"
            labelName="TAN No."
            placeholder="TAN No."
            name="tanNo"
            register={register}
            errorMessage={ErrorMessage(errors?.tanNo?.message)}
          />
        </Col>
      </div>

      <div className="form-container">
        <Col className="responsive-input" md={5}>
          <div>
            <RadioButtonsGroup
              formLabel={"Type"}
              name="supplierType"
              radioButtonArr={supplierTypes}
              control={control}
              defaultValue={"manufacturer"}
            />
          </div>
        </Col>

        <Col md={4} className=" mb-lg-0 mb-2">
          <label style={{ fontWeight: 600 }}>Account Group</label>
          <Controller
            name={"accountGroupId"}
            control={control}
            render={({ field }) => (
              <Select
                // styles={{
                //   ...selectInputStyle,
                //   control: (baseStyles) => ({
                //     ...baseStyles,
                //     width: "99%",
                //     paddingRight: "15px",
                //   }),
                // }}
                styles={{
                  ...selectInputStyle,
                  control: (base, state) => {
                    const originalControl = selectInputStyle.control?.(base, state) || base;
                    return {
                      ...originalControl,
                      width: "99%",
                      paddingRight: "15px",
                      // width: "100%",
                      minWidth : "100%",
                      maxWidth : "100%"
                    };
                  },
                }}
                options={accountGroupArrs}
                menuPortalTarget={document.body}
                {...field}
                onChange={(selectedOption) => {
                  field.onChange(selectedOption);
                }}
              />
            )}
          />
        </Col>
        {
          taxtype == "vat" && (
            <Col>
            <InputField
              labelName="VAT No."
              placeholder="VAT No"
              name="vatNo"
              id="vatNo"
              register={register}
              errorMessage={ErrorMessage(errors?.vatNo?.message)}
            />
          </Col>
          )
        }
      </div>
     
      <div className="form-container mt-3">
        <Col md={"auto"}>
          <InputField
             id =""
            labelName="Date Of Birth"
            placeholder="Date Of Birth"
            name="dateOfBirth1"
            register={register}
            onChange={(e) => {
              const selectedDate = new Date(e.target.value);
              const today = new Date();

              // Reset the time component of today
              today.setHours(0, 0, 0, 0);
              // Reset the time component of the selected date to midnight
              selectedDate.setHours(0, 0, 0, 0);

              if (selectedDate > today) {
                // Reset the input field or show an error message
                e.target.value = ""; // Optional: Clear the input if the date is invalid
                toastMessage(
                  "The selected date cannot be in the future. Please choose a valid date"
                );
              }
            }}
            inputType="date"
          />
        </Col>
        <Col>
          <InputField
           id= ""
            labelName="Anniversary Date"
            placeholder="Anniversary Date"
            name="anniversaryDate1"
            onChange={(e) => {
              const selectedDate = new Date(e.target.value);
              const today = new Date();

              // Reset the time component of today
              today.setHours(0, 0, 0, 0);
              // Reset the time component of the selected date to midnight
              selectedDate.setHours(0, 0, 0, 0);

              if (selectedDate > today) {
                // Reset the input field or show an error message
                e.target.value = ""; // Optional: Clear the input if the date is invalid
                toastMessage(
                  "The selected date cannot be in the future. Please choose a valid date"
                );
              }
            }}
            register={register}
            inputType="date"
          />
        </Col>
 
        {window.location.href.includes("/new") && (
          <>
            <Col>
              <InputField
                
                labelName="Opening Balance"
                placeholder="Debit Amount"
                name="debitAmount"
                id="debitAmount"
                register={register}
                inputType="number"
                onKeyDown={(evt) =>
                  ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()
                }
                onBlur={handleBlurDebitAmount}
                errorMessage={ErrorMessage(errors?.debitAmount?.message)}
              />
            </Col>

            <Col md={"auto"}>
              <InputField
                 id="creditAmount"
                labelName="Credit Amount"
                hiddenLabel={true}
                placeholder="Credit Amount"
                name="creditAmount"
                register={register}
                inputType="number"
                onKeyDown={(evt) =>
                  ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()
                }
                 errorMessage={ErrorMessage(errors?.creditAmount?.message)}
                onBlur={handleBlurCreditAmount}
              />
            </Col>
          </>
        )}

        <Col>
          <label style={{ fontWeight: 600 }}>Payment Terms</label>
          <Controller
            name={"paymentTermId"}
            control={control}
            render={({ field }) => (
              <Select
                placeholder={"Select Payment Terms"}
                styles={selectInputStyle}
                options={paymentTermArr}
                menuPortalTarget={document.body}
                {...field}
                onChange={(selectedOption) => {
                  field.onChange(selectedOption);
                }}
              />
            )}
          />
        </Col>
      </div>

      <div className="form-container mt-3">
        <Col md={"auto"}>
          <InputField
           labelName="Bank Name"
            placeholder="Bank Name"
            name="bankName"
            register={register}
            errorMessage={ErrorMessage(errors?.bankName?.message)}
          />
        </Col>
        <Col>
          <InputField
            labelName="Branch"
            placeholder="Branch"
            name="bankBranch"
            register={register}
            errorMessage={ErrorMessage(errors?.bankBranch?.message)}
          />
        </Col>

        <Col>
          <InputField
            labelName="Account No."
            placeholder="Account No."
            name="bankAcNo"
            register={register}
            errorMessage={ErrorMessage(errors?.bankAcNo?.message)}
          />
        </Col>
        <Col>
          <InputField
            labelName="IFSC Code"
            placeholder="IFSC Code"
            name="bankIfsc"
            register={register}
            errorMessage={ErrorMessage(errors?.bankIfsc?.message)}
          />
        </Col>
        <Col>
          <InputField
            labelName="Remarks"
            placeholder="Remarks"
            name="remark"
            register={register}
            errorMessage={ErrorMessage(errors?.remark?.message)}
          />
        </Col>
      </div>
    </>
  );
};

export default SuppliersDetailForm;
